<template>
    <div class="sloution">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box"><span class="shuxian">| </span> 产品服务</p>
                <ul class="box-ul1">
                    <li @click="jumpZY">
                        <img src="http://img601.yun300.cn/repository/image/797ebf0e-c764-4fad-bb20-416d56a3ff83.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">钉钉专业版</p>
                        <p class="li-p2">更专业的功能/更智能的搭建/更贴心的服务</p>
                    </li>
                    <li @click="jumpZS">
                        <img src="http://img601.yun300.cn/repository/image/759869c6-8633-4ec0-bcec-cbb02634ca61.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">专属钉钉</p>
                        <p class="li-p2">更开放的设计能力，更开放的集成能力</p>
                    </li>
                    <li @click="jumpZYDD">
                        <img src="http://img601.yun300.cn/repository/image/9053741d-7e3f-4cb6-83f3-21b055e9b718.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">专有钉钉</p>
                        <p class="li-p2">本地部署，全链路安全协同办公</p>
                    </li>
                </ul>
                <p class="title-box"><span class="shuxian">| </span> 行业解决方案</p>
                <ul class="box-ul1 uls">
                    <li @click="jumpGC">
                        <img src="http://img601.yun300.cn/repository/image/179078b4-2943-4cf8-be20-7d53fea18fc8.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">工程管理</p>
                        <p class="li-p2">利用数字化技术建立规范的管理标准</p>
                    </li>
                    <li @click="jumpSP">
                        <img src="http://img601.yun300.cn/repository/image/91fbb657-0f72-41e8-886d-d7e1ef5afe63.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">视频会议</p>
                        <p class="li-p2">随时随地一键发起视频会议</p>
                    </li>
                    <li @click="jumpYS">
                        <img src="http://img601.yun300.cn/repository/image/c1d58cfd-bc22-4c39-b9c1-d41896793105.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">云枢</p>
                        <p class="li-p2">企业数字化办公平台</p>
                    </li>
                </ul>
                <ul class="box-ul1 uls">
                    <li @click="jumpYD">
                        <img src="http://img601.yun300.cn/repository/image/f9b462f8-09fa-4802-a5fc-07425fb22edf.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">宜搭</p>
                        <p class="li-p2">助力生产力创新，加速企业数字化转型</p>
                    </li>
                    <li @click="jumpCY">
                        <img src="http://img601.yun300.cn/repository/image/ef136a3e-db6f-4180-b736-9759c0af0ac1.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">氚云</p>
                        <p class="li-p2">人人会用的数字化管理工具</p>
                    </li>
                </ul>
                <p class="title-box"><span class="shuxian">| </span> 工作台 云端办公室</p>
                <ul class="box-ul1">
                    <li @click="jumpGJ">
                        <img src="http://img601.yun300.cn/repository/image/86e8fc46-c018-452c-8b09-b73b0fd860c5.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">高级工作台</p>
                        <p class="li-p2">轻量+适配型+专业化</p>
                    </li>
                    <li @click="jumpDZ">
                        <img src="http://img601.yun300.cn/repository/image/811c4065-b4a3-43b2-a7a5-579421642fa7.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">定制工作台</p>
                        <p class="li-p2">打造成千行千面、千人千面的组织专属工作台</p>
                    </li>
                    <li @click="jumpYDBGS">
                        <img src="http://img601.yun300.cn/repository/image/d13ef2fc-badb-45f4-932c-b2615a61cf20.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-p1">云端办公室</p>
                        <p class="li-p2">远程协作、高效办公</p>
                    </li>
                </ul>
                <div class="hh" style="height:40px"></div>
            </div>
        </div>
    </div>
</template>
        
<script>
export default {
   methods: {
    jumpZY(){
        this.$router.push({name:"major"})
    },
    jumpZS(){
        this.$router.push({name:"onlyDingding"})
    },
    jumpZYDD(){
        this.$router.push({name:"haveDingding"})
    },
    jumpGC(){
        this.$router.push({name:"engineeringManagement"})
    },   
    jumpSZ(){
        this.$router.push({name:"digitalFactory"})
    },
    jumpSP(){
        this.$router.push({name:"videoconferencing"})  
    },
    jumpYS(){
        this.$router.push({name:"yunshu"})  
    },
    jumpYD(){
        this.$router.push({name:"yida"})  
    },
    jumpCY(){
        this.$router.push({name:"chuanyun"})  
    },
    jumpYZC(){
        this.$router.push({name:"roundAssets"})  
    },
    jumpGJ(){
        this.$router.push({name:"highWork"})  
    },
    jumpDZ(){
        this.$router.push({name:"onlyWork"})  
    },
    jumpYDBGS(){
        this.$router.push({name:"OACloud"})  
    }

   }
}
</script>
<style lang='less' scoped>
.sloution{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/ddjjfa_1920337.5@1x.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        background-color: rgba(245, 245, 245, 1);
        .box-cont1{
            width: 80%;
            margin: 0 auto;
            .title-box{
                font-size: 26px;
                color: #000;
                line-height: 90px;
                .shuxian{
                    color:#0089ff;
                    font-weight: bold;
                    font-size: 26px;
                    margin-right: 4px;
                }
            }
            .box-ul1{
                width: 100%;
                display: flex;
                // justify-content: space-between;
                li{
                    border-radius: 6px;
                    background-color: #fff;
                    width: 32%;
                    padding: 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                    transition: all 0.2s linear;
                    margin-right: 1.5%;
                    img{
                        width: 60px;
                        height: 60px;
                        margin-top: 10px;
                    }
                    .li-p1{
                        font-size: 22px;
                        color:#000000;
                        margin-bottom: 12px;
                        margin-top: 12px;
                    }
                    .li-p2{
                        font-size: 17px;
                        color:#808080;
                        margin-top: 7px;
                    }
                }
                li:hover{
                    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
                }
            }
        }
    }
}
.uls{
    margin-bottom: 20px;
}
</style>